import React, { useState, useEffect } from "react";
import TokenForm from "./components/TokenForm";
import Login from "./components/Login";
import TokenPage from "./components/TokenPage";
import { useNavigate } from "react-router-dom";
import "./App.css";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [showRegister, setShowRegister] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      localStorage.removeItem("token");
    }
  }, [token]);
  const handleTokenCreated = () => {
    setRefresh((prev) => !prev);
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
    navigate("/");
  };
  if (!token)
    return (
      <div className="p-4">
        <h1 className="text-xl font-bold mb-4 text-center">
          Courtyard Sand Import Token Handler
        </h1>
        <Login setToken={setToken} />
      </div>
    );

  return (
    <div className="token-system-container">
      <button className="menu-button" onClick={handleLogout}>
        Logout
      </button>
      <h1 className="token-system-title">Sand Import Token System</h1>
      <TokenForm authToken={token} onTokenCreated={handleTokenCreated} />
      <TokenPage authToken={token} reload={refresh} />
    </div>
  );
}

export default App;
